module.exports = __webpack_public_path__ + "img/logo-bubble.6398563b.svg";